import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Setup API base URL
const API = axios.create({
    baseURL: process.env.REACT_APP_URL,
});

// Set token in headers
API.interceptors.request.use((req) => {
    const token = localStorage.getItem('token');
    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
});
export type Photo = '';

export const fetchPhotos = createAsyncThunk<Photo[], string>(
    'photos/fetchPhotos',
    async (albumId, { rejectWithValue }) => {
        try {
            const response = await API.get(`/images/album/${albumId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data?.message || 'Failed to fetch photos');
        }
    }
);

// Thunk for single upload
export const uploadSingleImage = createAsyncThunk(
  'photos/uploadSingleImage',
  async (formData: FormData, { rejectWithValue }) => {
      try {
          const res = await API.post('/images', formData);
          return res.data;
      } catch (error: any) {
          return rejectWithValue(error?.response?.data?.message || 'Single image upload failed');
      }
  }
);

// Thunk for multiple uploads
export const uploadMultipleImages = createAsyncThunk(
  'photos/uploadMultipleImages',
  async (formData: FormData, { rejectWithValue }) => {
      try {
          const res = await API.post('/images/multi', formData);
          return res.data;
      } catch (error: any) {
          return rejectWithValue(error?.response?.data?.message || 'Multiple image upload failed');
      }
  }
);